import {css} from 'emotion'
import { Colors } from './..'

export const SocialStyle = css({
  '.social': {
    '&-col': {
      maxWidth: '100%',
      flexBasis: '100%',
      '@media (min-width: 1024px)': {
        maxWidth: 'calc(1/3 * 100% - 2rem)',
        flexBasis: 'calc(1/3 * 100% - 2rem)',
        margin: '0 1rem',
      },
      '&:first-child': {
        marginLeft: 0,
      },
      '&:last-child': {
        marginRight: 0,
      }
    },
    '&-box': {
      padding: '1rem',
      margin: '2rem 0',
      border: `1px solid ${Colors.mediumGrey}`,
      '@media (min-width: 1O24px)': {
        margin: '4rem 0',
        padding: '2rem',
      },
    },
    '&-title': {
      textTransform: 'uppercase',
      margin: 0,
      wordBreak:  'break-all',
    },
    '&-date': {
      fontSize: '0.75rem'
    },
    '&-desc': {
      fontSize: '0.9375rem'
    },
    '&-head': {
      maxWidth: 'calc(100% - 40px)',
      flexBasis: 'calc(100% - 40px)',
      marginLeft: '10px'
    },
    '&-container': {
      margin: '2rem 0',
      '@media (min-width: 1024px)': {
        margin: '4rem 0',
      }
    }
  },
  'a': {
    color: 'black',
  },
  'img': {
    maxWidth: '100%',
    maxHeight: '100%',
  },
})


// WEBPACK FOOTER //
// ./src/styles/containers/social.js